export enum TranslationState {
  TranslationMissing = 'TranslationMissing',
  Translated = 'Translated',
  ManuallyTranslated = 'ManuallyTranslated',
  MainLanguage = 'MainLanguage',
  MainLanguageUpdated = 'MainLanguageUpdated',
  TranslationPending = 'TranslationPending',
  PartiallyTranslated = 'PartiallyTranslated',
}
